import { createContext, useContext } from "react";

/**
 * Logical state for a rail retained by EntityWorkspace during its visual exit.
 * The default keeps standalone WorkspaceRightRail stories/tests open.
 */
export const WorkspaceRightRailOpenContext = createContext(true);

export function useWorkspaceRightRailOpen(): boolean {
  return useContext(WorkspaceRightRailOpenContext);
}

/**
 * The width the workspace will reserve once its rail transition settles.
 *
 * Floating control groups use this target instead of the intermediate flex
 * width while the rail is moving. That lets responsive controls choose their
 * final density once, rather than crossing several breakpoints during a single
 * open or close animation.
 */
export const WorkspaceRightRailTargetWidthContext = createContext(0);

export function useWorkspaceRightRailTargetWidth(): number {
  return useContext(WorkspaceRightRailTargetWidthContext);
}
